<template>
  <card-total>
    <div slot="title">
      <div class="cardCustom__header">
        <div class="cardCustom__header-text">
          <span class="uppercase">
            {{ title }}
          </span>
        </div>
        <div class="chart-dropdown">
          <slot name="dropdown"></slot>
        </div>
        <div class="cardCustom__header-info__item">
          <button
            v-tooltip="{
              content: 'Total Progress of your club for current year',
              placement: 'bottom-center',
              classes: ['info'],
            }"
          >
            <i class="fas fa-info-circle" />
          </button>
        </div>
      </div>
    </div>
    <div slot="content">
      <div :id="chartId"></div>
      <div class="chart-legend">
        <slot name="legend"></slot>
      </div>
    </div>
  </card-total>
</template>
<script>
import CardTotal from '@/components/Cards/CardTotal';
export default {
  name: 'chart-card',
  components: {
    CardTotal,
  },
  props: {
    footerText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    chartType: {
      type: String,
      default: 'Line', // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          labels: [],
          series: [],
        };
      },
    },
  },
  data() {
    return {
      chartId: 'no-id',
    };
  },
  mounted() {
    this.updateChartId();
    import('chartist').then((Chartist) => {
      let ChartistLib = Chartist.default || Chartist;
      this.$nextTick(() => {
        this.initChart(ChartistLib);
      });
    });
  },
  methods: {
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart(Chartist) {
      const chartIdQuery = `#${this.chartId}`;
      Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    /***
     * Assigns a random id to the chart
     */
    updateChartId() {
      const currentTime = new Date().getTime().toString();
      const randomInt = this.getRandomInt(0, currentTime);
      this.chartId = `div_${randomInt}`;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
};
</script>
<style>
.ct-series-a .ct-line {
  /* Set the colour of this series line */
  stroke: #73ab6b;
}

.ct-series-a .ct-point {
  /* Set the colour of this series line */
  stroke: #73ab6b;
}

.ct-label {
  width: 35px !important;
}
</style>
